import Component from 'vue-class-component';
import Vue from 'vue';

@Component({
  props: {
    myDataUrl: String,
    logoutUrl: String,
    myAccount: String,
    username: String,
    label: Object,
    state: String,
    linkClass: String,
  },
})
export default class LoginWorldWide extends Vue {
}
